/**
 * Where clicking a notification should take the user.
 * Ticket notifications jump straight to the ticket; everything else opens the
 * generic notification detail page.
 */
export const notificationTarget = (n) => {
  if (!n) return "/user/notifications";
  if (n.requestType === "Ticket") {
    return (
      n.link ||
      (n.requestId
        ? `/ticketing/tickets/${n.requestId}`
        : `/user/notifications/${n.id}`)
    );
  }
  return `/user/notifications/${n.id}`;
};
